import none from "./none";

export default function(series) {
  return none(series).reverse();
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-shape/src/order/reverse.js
// module id = XWZe
// module chunks = 0